import { render, staticRenderFns } from "./Etapa4.vue?vue&type=template&id=0272a1bc&scoped=true"
import script from "./Etapa4.vue?vue&type=script&lang=js"
export * from "./Etapa4.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&id=0272a1bc&prod&scoped=true&lang=scss&external"
import style1 from "./Etapa4.vue?vue&type=style&index=1&id=0272a1bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0272a1bc",
  null
  
)

export default component.exports